import classNames from 'classnames'

import { Skeleton } from '../Skeleton'

import * as styles from './Headline2.module.css'

function Headline2({ children, className, isSecondary, isSkeleton, ref }) {
  const headlineClassName = classNames(
    styles.headline2,
    {
      [styles.secondary]: isSecondary,
    },
    className
  )

  return isSkeleton ? (
    <Skeleton className={styles.skeleton} />
  ) : (
    <h2 className={headlineClassName} ref={ref}>
      {children}
    </h2>
  )
}

export { Headline2 }
